import { render, staticRenderFns } from "./HelpTextCreate.vue?vue&type=template&id=08533ae6&scoped=true&"
import script from "./HelpTextCreate.vue?vue&type=script&lang=js&"
export * from "./HelpTextCreate.vue?vue&type=script&lang=js&"
import style0 from "./HelpTextCreate.vue?vue&type=style&index=0&id=08533ae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08533ae6",
  null
  
)

export default component.exports